import { didApiUrl } from '@/environment';
import { authenticatedAxios } from '@/services/auth';
import { CampaignAccess, ClipPresenter, ICampaign, TalkPresenter } from '@d-id/types';

export interface GetCampaignsResponse {
    campaigns: ICampaign[];
    token?: string;
}

export const getCampaigns = async (token?: string): Promise<GetCampaignsResponse> => {
    const response = await authenticatedAxios.get(`${didApiUrl}/campaigns`, { params: { token } });
    return response.data;
};

export interface UpdateCampaignData {
    name?: string;
    access?: CampaignAccess;
}
export const updateCampaign = async (id: string, updateData: UpdateCampaignData) => {
    const response = await authenticatedAxios.patch(`${didApiUrl}/campaigns/${id}`, updateData);
    return response.data;
};

export const deleteCampaign = async (id: string) => {
    const response = await authenticatedAxios.delete(`${didApiUrl}/campaigns/${id}`);
    return response.data;
};

export interface CreateCampaignRequestDto {
    id: string;
    duration: number;
    script: string;
    script_fields: string[];
    title?: string;
    description?: string;
    logo_src?: string;
    cta_enabled?: boolean;
    cta_text?: string;
    cta_url?: string;
    cta_background_color?: string;
    presenter?: TalkPresenter | ClipPresenter;
    agent_id?: string;
}

export const createCampaign = async (data: CreateCampaignRequestDto) => {
    const response = await authenticatedAxios.post(`${didApiUrl}/campaigns`, data);
    return response.data;
};
